import * as Types from '../../../__generated__/schema';

import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
export type Notification = Pick<
  Types.Notification,
  'id' | 'userId' | 'topic' | 'level' | 'title' | 'message' | 'createdAt' | 'readAt' | 'archivedAt'
> & {
  metadata?: Types.Maybe<
    Pick<
      Types.NotificationMetadata,
      | 'alertID'
      | 'originalQueryId'
      | 'presignedUrl'
      | 'presignedUrlTtl'
      | 'presignedUrlKeepAliveDuration'
    >
  >;
};

export const Notification = gql`
  fragment Notification on Notification {
    id
    userId
    topic
    level
    title
    message
    createdAt
    readAt
    archivedAt
    metadata {
      alertID
      originalQueryId
      presignedUrl
      presignedUrlTtl
      presignedUrlKeepAliveDuration
    }
  }
`;
